module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1dd834e80897df09d4e7c0277da2d1a7.gif";